export interface IServiceAdminToolsAuthorizationConfig {
    isServiceAvailability: string
    isRefreshMemoryObjects: string
    isApprovedServices: string
    isEmailWebPages: string
    isManageMessages: string
    isManageOffers: string
}

export const ServiceAdminUserToolsPrevilages = () => {
    const ServiceAdminTools: IServiceAdminToolsAuthorizationConfig = {
        isServiceAvailability: 'Enabled',
        isRefreshMemoryObjects: 'Enabled',
        isApprovedServices: 'Enabled',
        isEmailWebPages: 'Enabled',
        isManageMessages: 'Enabled',
        isManageOffers: 'Enabled'
    }

    const adminHashMap = new Map<string, IServiceAdminToolsAuthorizationConfig>()
    adminHashMap.set('ServiceAdminTools', ServiceAdminTools)

    return adminHashMap
}

export const defaultServiceAdminUserTools: IServiceAdminToolsAuthorizationConfig = {
    isServiceAvailability: 'Disabled',
    isRefreshMemoryObjects: 'Disabled',
    isApprovedServices: 'Disabled',
    isEmailWebPages: 'Disabled',
    isManageMessages: 'Disabled',
    isManageOffers: 'Disabled'
}
